import { createContext } from "react";

/**
 * The `TooltipStyleContext` value.
 */
export interface TooltipStyleContextValue {
  /**
   * The appearance of the tooltip. Defaults to `"dark"` if not specified.
   */
  readonly appearance: "light" | "dark";

  /**
   * The alignment of child tooltips relative to the element.
   */
  readonly alignment: "top" | "bottom" | "left" | "right" | "cursor";
}

/**
 * The tooltip style context.
 */
export const TooltipStyleContext = createContext<TooltipStyleContextValue>({
  appearance: "dark",
  alignment: "cursor",
});
